import content from "../content"
import articleList from "../items/article_list"
import articleCreate from "../items/article_create"
import articleEdit from "../items/article_edit"
import resourceList from "../items/resource_list"

export default {
	path:'content',
	name:'content',
	component:content,
	children:[
		{
			path:'article/list',
			name:'article-list',
			component:articleList
		},
		{
			path:'article/create',
			name:'article-create',
			component:articleCreate
		},
		{
			path:'article/edit',
			name:'article-edit',
			component:articleEdit
		},
		{
			path:'resource/list',
			name:'resource-list',
			component:resourceList
		},
	]
}